export default __webpack_public_path__ + "static/media/Chaptertitle.b01defc9.txt";